import { useTranslate } from '~/shared/context/use-translate';
import { ActivityTimelineCard } from '~/ui/domain/chat/ActivityTimelineCard';

import type { ActivityTimelineBlock } from '../../data-contract/chat';
import type { BlockRenderContext, BlockRenderer } from './types';

const hasOpenStep = (block: ActivityTimelineBlock): boolean =>
    block.steps.some((step) => step.status === 'active' || step.status === 'pending');

const ActivityTimeline = ({
    block,
    context,
}: {
    readonly block: ActivityTimelineBlock;
    readonly context: BlockRenderContext;
}) => {
    const translate = useTranslate();
    return (
        <ActivityTimelineCard
            autoCollapseWhenComplete={true}
            doneLabel={translate('common.done')}
            isClosed={block.isClosed === true}
            isTurnComplete={context.isTurnComplete}
            steps={block.steps}
            title={block.title}
            usage={block.usage}
        />
    );
};

export const activityTimelineBlockRenderer: BlockRenderer<ActivityTimelineBlock> = {
    isAnswered: (block) => !hasOpenStep(block),
    renderInline: (block, context) => <ActivityTimeline block={block} context={context} />,
    type: 'activity-timeline',
};
